import { apiRequest } from '@/lib/api/client'
import {
  profileSchema,
  saveProfileResponseSchema,
  saveProfileSchema,
  type SaveProfileInput,
} from './schema'

const PROFILE_PATH = '/v1/algo-pos-be/liotitip/profile'

export function fetchProfile(signal?: AbortSignal) {
  return apiRequest(PROFILE_PATH, { schema: profileSchema, signal })
}

export function saveProfile(input: SaveProfileInput) {
  return apiRequest(PROFILE_PATH, {
    method: 'PUT',
    schema: saveProfileResponseSchema,
    body: saveProfileSchema.parse(input),
  })
}
